import { Component, OnInit, ChangeDetectorRef, OnDestroy, AfterViewInit, Inject, ElementRef, ViewChild } from '@angular/core';
import { MediaMatcher } from '@angular/cdk/layout';
import { RequestInProgressService }  from '@trivelope/triv-ui-tools-lib';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { User, UserRoles } from 'src/app/classes/user';
import { Subscription } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';
import { CalendarTypeService } from 'src/app/services/calendar-type.service';
import { Environment } from 'src/app/classes/environment';
import { DocumentExchangeService } from 'src/app/services/document-exchange.service';
import { DocumentExchangeCategory } from 'src/app/classes/document-exchange';
import { MatSidenav } from '@angular/material/sidenav';
import { NewCountersService } from 'src/app/services/new-counters.service';
import { CustomerService } from 'src/app/services/customer.service';
import { SafeUrl } from '@angular/platform-browser';



@Component({
	selector: 'app-layout',
	templateUrl: './layout.component.html',
	styleUrls: ['./layout.component.css']
})
export class LayoutComponent implements  OnInit, OnDestroy, AfterViewInit {


	private _mobileQueryListener = (e: any) => {};
	mobileQuery = this.media.matchMedia('(max-width: 959px)');

	user = new User();
	bAdmin = false;
	subscriptions = new Subscription();
	isInternalCalendar = false;

	UserRoles = UserRoles;	// to be used in the template

	nameShown = "";

	hasExchangeGroups = false;
	submenuCategories: DocumentExchangeCategory[] = [];

	@ViewChild( 'snav' ) snav!: MatSidenav;

	newNews = "";
	newDocuments = "";
	newChats = "";

	logoSrc: SafeUrl = "";


	constructor(
		private changeDetectorRef: ChangeDetectorRef,
		private media: MediaMatcher,
		private requestInProgressService: RequestInProgressService,
		private authService: AuthenticationService,
		private router: Router,
		private calendarTypeService: CalendarTypeService,
		@Inject( "environment" ) public environment: Environment,
		private documentExchangeService: DocumentExchangeService,
		private newCountersService: NewCountersService,
		private customerService: CustomerService,
	) {

		this._mobileQueryListener = () => {
			changeDetectorRef.detectChanges();
		};
		this.mobileQuery.addEventListener( 'change', this._mobileQueryListener );

	}


	ngOnInit() {

		this.logoSrc = this.customerService.getLoadedLogo();

		this.subscriptions.add(
			this.requestInProgressService.bInProgress.subscribe( b => {

				this.changeDetectorRef.detectChanges();

			})
		);

		this.subscriptions.add(
			this.router.events.subscribe( event => {
				if( !this.mobileQuery.matches ) return;
				if( event instanceof NavigationEnd ) {
					this.snav.close();
				}
			})
		);

		this.user = this.authService.getCurrentUser();

		const arr: string[] = [];
		if( this.user.ebeVorname ) arr.push( this.user.ebeVorname );
		if( this.user.ebeName ) arr.push( this.user.ebeName );
		this.nameShown = arr.length ? arr.join( " " ) : this.user.ebeId;

		this.bAdmin = this.authService.isAdmin();

		if( this.bAdmin ) {
			this.hasExchangeGroups = true;
		}

		if( this.environment.features.austausch ) {

			this.subscriptions.add(
				this.documentExchangeService.getDocumentExchangeCategories().subscribe( categories => {
					if( categories ) {
						this.submenuCategories = categories.filter(category => category.agSubmenu === true)
							.sort((a, b) => a.name.localeCompare(b.name));
						this.hasExchangeGroups = !!this.submenuCategories.length;
					}
					this.changeDetectorRef.detectChanges();
				})
			);

		}

		this.subscriptions.add(
			this.newCountersService.newChats.asObservable().subscribe( str => {
				this.newChats = str;
			})
		);

		this.subscriptions.add(
			this.newCountersService.newDocuments.asObservable().subscribe( str => {
				this.newDocuments = str;
			})
		);

		this.subscriptions.add(
			this.newCountersService.newNews.asObservable().subscribe( str => {
				this.newNews = str;
			})
		);

	}

	ngAfterViewInit(): void {
		this.changeDetectorRef.detectChanges();
	}

	setCalendarType( isInternal: boolean ) {
		this.calendarTypeService.setInternalCalendar(isInternal); // Set calendar type
	}


	resetCategories() {
		// Navigation zur Austauschseite ohne Query-Parameter
		this.router.navigate(['/Austausch']);
	}

	disconnect() {

		this.authService.logout();
		this.router.navigate( ['/auth/login'] );

	}


	ngOnDestroy(): void {
		this.mobileQuery.removeEventListener('change', this._mobileQueryListener);
		this.subscriptions.unsubscribe();
	}


}
